module.exports = __webpack_public_path__ + "static/media/resize-circle-white.669ce0cf.svg";